<template>
    <div class="footer" v-bind:class="{ 'fixed-bottom': fixes_pages() }">
            <div class="row pt-2 pb-2">
              <div class="col-12 text-center col-md-auto   mr-md-auto">
                  <img :src="require('../assets/logo_footer.svg')" alt="" class="text-center text-md-left img-fluid logo-footer">
              </div>
              <div class="col-12 text-center text-md-left col-md-auto text-footer">
                  +595 0991 290 936 <br>
                  info@espais.com.py
               </div>
                <div class="col-12 text-center text-md-left col-md-auto text-footer">
                    Rca. Dominicana 997 esq. Amistad <br>
                    4to Piso, Asunción - Paraguay 
                </div>
                <div class="direccion-logos col-12 col-md-auto">
                    <a href="https://www.facebook.com/ArquitecturaEspais/" target="_blank" class=""> <i class="fab fa-facebook"></i></a>
                    <a href="https://www.instagram.com/espais.arquitectura/" target="_blank"><i class="fab fa-instagram"></i></a>
                        <a href="https://www.pinterest.es/espaisarquitectura/" target="_blank"><i class="fab fa-pinterest-square"></i></a>
                </div>
              
            
              
            
            </div>
    </div>
</template>

<script>
export default {
    methods:{
        fixes_pages(){
            if(this.$route.path === '/' ||  this.$route.name === 'Servicios' ){
                return true;
               
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Footer.vue